import { Card } from "../atoms/Card";
import { LabelValue } from "../atoms/LabelValue";
import { StatusBadge } from "../atoms/StatusBadge";
import { Button } from "../atoms/Button";

export function VisitorInfoCard({
  visitor,
  status,
  onCheckin,
  checkinLoading
}) {
  if (!visitor) return null;

  return (
    <Card>
      {/* 操作 */}
      {onCheckin && (
        <div style={{ marginBottom: 12 }}>
          <Button
            variant={status === "checked" ? "ghost" : "secondary"}
            size="xl"
            fullWidth
            onClick={onCheckin}
            disabled={status === "checked" || checkinLoading}
          >
           {status === "checked" ? "受付済み" 
            : checkinLoading ? "受付中..."
            :"受付する"}
          </Button>
        </div>
      )}

      {/* ヘッダ */}
      <div style={{ marginBottom: 12 }}>
        <StatusBadge status={status} />
      </div>

      {/* 基本情報 */}
      <LabelValue label="氏名" value={visitor.visitor_name} />
      <LabelValue label="よみ" value={visitor.visitor_name_kana} />
      <LabelValue label="会社名" value={visitor.company_name} />
      <LabelValue label="部署" value={visitor.department_name} />
      <LabelValue label="役職" value={visitor.position_name} />
      <LabelValue label="業種" value={visitor.industry} />
      <LabelValue label="来場希望日" value={visitor.preferred_visit_date} />
      <LabelValue label="参加予定イベント" value={visitor.event_name} />

      {/* セミナー */}
      <LabelValue
        label="参加セミナー"
        value={
          visitor.applied_seminars?.length
            ? visitor.applied_seminars.join(" / ")
            : "なし"
        }
      />
    </Card>
  );
}